import { Box, Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import { GenericInput } from "components/GenericInput/GenericInput"
import NextLink from "components/Reusable/Bit/NextLink"
import { useFormikContext } from "formik"
import dynamic from "next/dynamic"
import { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import { usePurchaseContext } from "./PurchaseContext"
import HeadingText from "./Texts/HeadingText"

const RecorderPage = dynamic(() => import("./RecorderPage"), { ssr: false })
const VideoPage = dynamic(() => import("./VideoBlessing/VideoPage"), {
  ssr: false,
})

const StyledWrapper = styled.div`
  position: relative;
  margin-top: 20px;
  .MuiOutlinedInput-root {
    width: 620px !important;
    height: 120px !important;
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: 100% !important;
    }
  }
  .MuiFormHelperText-root {
    display: none;
  }
  fieldset {
    height: 120px;
    top: 0px;
  }
`
const StyledTextBox = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 620px;
  }
`
const StyledTypography = styled(Typography).attrs({ variant: "body1" })`
  margin-top: 7px;
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  margin-top: 7px;
  font-family: "NarkisBlock", sans-serif;
  font-weight: 500;
  a {
    text-decoration: none;
    margin-left: 5px;

    text-decoration: underline;
  }
`
const StyledBox = styled(Box)`
  margin-top: 60px;
  .MuiOutlinedInput-root {
    ${(p) => p.theme.breakpoints.up("md")} {
      height: 40px;
      width: 200px;
    }
    .MuiInputBase-inputMultiline {
      height: 100% !important;
      font-size: 20px;
      color: #000;
      font-family: Speedee, NarkisBlock, sans-serif;
      font-weight: 500;
    }
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 30px;
  }
`

const StyledFieldWrapper = styled(Box)`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    .MuiFormControl-root {
      margin-left: 10px;
    }
    > * {
      width: 200px;
    }
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    .MuiFormHelperText-contained {
      display: none;
    }
    .MuiFormHelperText-contained.Mui-error {
      display: block;
    }
  }
`

const StyledFieldBox = styled(Box)`
  margin-left: 10px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    > * {
      width: 100%;
    }
  }
`

const StyledtextWrapp = styled(Box)`
  display: flex;
  justify-content: space-between;
`

const StyledContactTextWrapp = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 10px;
`

const StyledContactText = styled(Typography).attrs({ variant: "body1" })`
  color: #264f36;
  font-family: "NarkisBlock";
  cursor: pointer;
  text-decoration: underline;
`

const StyledContactError = styled(Typography).attrs({ variant: "body1" })`
  font-size: 18px;
  color: #d70202;
  line-height: 110%;
`

const MediaButtons = styled(Box)<{ $justify?: string }>`
  display: flex;
  justify-content: ${(p) => p.$justify && p.$justify};
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 620px;
  }
`

const StyledGenericInput = styled(GenericInput)``

type OtherPersonFieldsProps = {
  formatPhoneNumber: (value: string) => string
  saveGiftCardData: (values: object) => void

  regex: RegExp
}

const OtherPersonFields = ({
  formatPhoneNumber,
  saveGiftCardData,
}: OtherPersonFieldsProps) => {
  const { values, setFieldValue } = useFormikContext<any>()
  const [contactError, setContactErrors] = useState(null)
  const [contacts, setContacts] = useState(null)
  const { purchaseData, setIsVideoApproved, isVideoApproved } =
    usePurchaseContext()

  const isDesktop = useIsDesktop()
  const emailRef = useRef(null)
  const [isAndroidChrome, setIsAndroidChrome] = useState(false)

  const handlePhoneInput = (evt, valueName: string) => {
    //only allow numbers without '-' symbol
    if (evt.target.value.length) {
      const formattedValue = formatPhoneNumber(evt.target.value)
      setTimeout(() => {
        console.log({ formattedValue })
        setFieldValue(valueName, formattedValue)
      }, 0)
    }
  }

  const updateFormikValues = (field, value) => {
    return setFieldValue(field, value)
  }

  const getContact = async () => {
    const supported = "contacts" in navigator && "ContactsManager" in window
    if (supported) {
      const opts = { multiple: false }
      const props = ["name", "email", "tel"]
      try {
        const contacts = await navigator.contacts.select(props, opts)
        setContacts(contacts)
        setContactErrors(null)
        contacts &&
          contacts.forEach((contact) => {
            if (contact.name) {
              updateFormikValues("recipientName", contact.name.toString())
            } else {
              updateFormikValues("recipientName", "")
            }
            if (contact.email) {
              updateFormikValues(
                "recipientEmail",
                contact.email.toString()?.trim()
              )
            } else {
              updateFormikValues("recipientEmail", "")
            }
            if (contact.tel) {
              if (contact.tel.length > 1) {
                updateFormikValues(
                  "phoneNumber",
                  formatPhoneNumber(contact.tel[0].toString())
                )
              } else {
                updateFormikValues(
                  "phoneNumber",
                  formatPhoneNumber(contact.tel.toString())
                )
              }
            } else {
              updateFormikValues("phoneNumber", formatPhoneNumber(""))
            }
          })
      } catch (ex) {
        setContactErrors("אופס לא הצליח, שננסה שוב?")
      }
    }
  }

  const handlePaste = () => {
    setTimeout(() => {
      emailRef.current.childNodes[1].firstChild.blur()
      emailRef.current.childNodes[1].firstChild.focus()
    }, 300)
  }

  useEffect(() => {
    const isChromeOnAndroid =
      /Chrome/i.test(navigator.userAgent) &&
      /Android/i.test(navigator.userAgent)
    setIsAndroidChrome(isChromeOnAndroid)
  }, [])

  return (
    <StyledBox>
      <StyledtextWrapp>
        <HeadingText
          text="למי המתנה?"
          tabIndex={0}
          marginBottom={!isDesktop ? 0 : 30}
        />
        {isAndroidChrome && (
          <StyledContactTextWrapp>
            <StyledContactText onClick={getContact}>
              {contacts ? "הוספת איש קשר אחר" : "הוספת איש/אשת קשר"}
            </StyledContactText>
            {contactError && (
              <StyledContactError>אופס לא הצליח, שננסה שוב?</StyledContactError>
            )}
          </StyledContactTextWrapp>
        )}
      </StyledtextWrapp>
      <StyledFieldWrapper>
        <StyledFieldBox>
          <GenericInput
            name="recipientName"
            label="שם/שם חיבה (*חובה)"
            type="text"
            maxLength={30}
            $width="200px"
            autoComplete="name"
            id="otherPersonRecipientName"
            topMargin={isDesktop ? "0" : "20"}
          />
        </StyledFieldBox>
        <StyledFieldBox>
          <GenericInput
            name="phoneNumber"
            label="טלפון (*חובה)"
            $width="200px"
            type="tel"
            numeric={true}
            onInput={(e) => handlePhoneInput(e, "phoneNumber")}
            onPaste={async (e) => {
              const clipboardData = e.clipboardData.getData("Text")
              setTimeout(async () => {
                const phone = formatPhoneNumber(clipboardData.toString())
                setFieldValue("phoneNumber", phone)
              }, 300)
            }}
            autoComplete="tel"
            topMargin={isDesktop && "0"}
          />
        </StyledFieldBox>

        <StyledFieldBox>
          <StyledGenericInput
            name="recipientEmail"
            label="אימייל"
            type="text"
            $width="200px"
            autoComplete="email"
            innerRef={emailRef}
            inputMode="email"
            $unicodeBidi={
              values?.recipientEmail?.match(/[a-zA-Z]/) ? "plaintext" : "normal"
            }
            topMargin={isDesktop && "0"}
            onPaste={handlePaste}
          />
        </StyledFieldBox>
      </StyledFieldWrapper>

      <StyledWrapper>
        <StyledFieldBox>
          <GenericInput
            name="senderBlessing"
            label="כתיבת ברכה"
            type="text"
            InputProps={{ multiline: true }}
            maxLength={100}
            topMargin={isDesktop && "0"}
          />
        </StyledFieldBox>

        <StyledTextBox>
          <StyledTypography>
            <Box
              component="span"
              fontWeight={
                values?.senderBlessing?.length > 0 ? "bold" : "normal"
              }
            >
              {values?.senderBlessing?.length || 0}
            </Box>
            /100
          </StyledTypography>
          <StyledText>
            <NextLink href="/ethics" onClick={() => saveGiftCardData(values)}>
              הקוד האתי שלנו
            </NextLink>
            לכתיבת ברכה
          </StyledText>
        </StyledTextBox>

        <MediaButtons
          $justify={
            (isVideoApproved || purchaseData?.audioBlessingBase64) &&
            "space-between"
          }
        >
          <RecorderPage />
          <VideoPage
            setIsApproved={setIsVideoApproved}
            isApproved={isVideoApproved}
          />
        </MediaButtons>
      </StyledWrapper>
    </StyledBox>
  )
}

export default OtherPersonFields
